var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGnb01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_2513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6735 19.9005H0.330145C0.150698 19.9005 0.00354004 19.7533 0.00354004 19.5739V2.42595C0.00354004 2.2465 0.150698 2.09937 0.330145 2.09937H21.6735C21.853 2.09937 22.0001 2.2465 22.0001 2.42595V19.5739C22.0001 19.7533 21.853 19.9005 21.6735 19.9005ZM0.65675 19.2473H21.3469V2.75255H0.65675V19.2473Z",
    fill: "#B69084",
    stroke: "#B69084",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6699 6.06872H0.326561C0.147115 6.06872 0 5.92156 0 5.74212V2.42595C0 2.2465 0.147115 2.09937 0.326561 2.09937H21.6699C21.8494 2.09937 21.9965 2.2465 21.9965 2.42595V5.74212C21.9965 5.92156 21.8494 6.06872 21.6699 6.06872ZM0.653166 5.41553H21.3434V2.75255H0.653166V5.41553Z",
    fill: "#B69084",
    stroke: "#B69084",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98098 4.41062C1.89485 4.41062 1.8123 4.37472 1.75128 4.31371C1.69027 4.2527 1.65442 4.17015 1.65442 4.08401C1.65442 3.99788 1.69027 3.91535 1.75128 3.85434C1.82665 3.77897 1.94152 3.74667 2.0456 3.76461C2.06713 3.7682 2.08868 3.77538 2.10663 3.78255C2.12816 3.78973 2.14607 3.80048 2.16402 3.81125C2.18196 3.82561 2.19991 3.83639 2.21427 3.85074C2.27528 3.91176 2.31118 3.99787 2.31118 4.08042C2.31118 4.16297 2.27528 4.2491 2.21427 4.31012C2.15326 4.37113 2.07071 4.40702 1.98457 4.40702L1.98098 4.41062Z",
    fill: "#B69084",
    stroke: "#B69084",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61537 4.41051C4.52924 4.41051 4.44669 4.37462 4.38567 4.3136C4.35696 4.28489 4.33182 4.24901 4.31746 4.20594C4.29952 4.16646 4.29236 4.12697 4.29236 4.08391C4.29236 3.99777 4.32825 3.91524 4.38927 3.85423C4.40362 3.83988 4.42157 3.8255 4.43952 3.81474C4.45746 3.80397 4.47537 3.79322 4.49691 3.78604C4.51485 3.77886 4.5364 3.77167 4.55794 3.76808C4.601 3.7609 4.64406 3.7609 4.68713 3.76808C4.70508 3.77167 4.73022 3.77886 4.74816 3.78604C4.7661 3.79322 4.78761 3.80397 4.80555 3.81474C4.8235 3.82909 4.84144 3.83988 4.85221 3.85423C4.91322 3.91524 4.94912 4.00136 4.94912 4.08391C4.94912 4.12697 4.94196 4.17005 4.92401 4.20594C4.90607 4.24901 4.88092 4.2813 4.85221 4.3136C4.7912 4.37462 4.70865 4.41051 4.62251 4.41051H4.61537Z",
    fill: "#B69084",
    stroke: "#B69084",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29816 4.41071C3.21203 4.41071 3.12948 4.37481 3.06847 4.3138C3.00745 4.25279 2.97156 4.17024 2.97156 4.0841C2.97156 3.99797 3.00745 3.91544 3.06847 3.85443C3.08282 3.84007 3.10077 3.8257 3.11872 3.81493C3.13666 3.80417 3.15462 3.79342 3.17615 3.78624C3.1941 3.77906 3.2156 3.77186 3.23714 3.76828C3.3448 3.75033 3.45608 3.78263 3.53145 3.858C3.59246 3.91901 3.62836 4.00515 3.62836 4.0877C3.62836 4.17024 3.59605 4.25638 3.53145 4.31739C3.47044 4.3784 3.38789 4.4143 3.30176 4.4143L3.29816 4.41071Z",
    fill: "#B69084",
    stroke: "#B69084",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3983 8.83578H2.96792C2.78847 8.83578 2.64136 8.68865 2.64136 8.5092C2.64136 8.32975 2.78847 8.18262 2.96792 8.18262H11.3983C11.5778 8.18262 11.7249 8.32975 11.7249 8.5092C11.7249 8.68865 11.5778 8.83578 11.3983 8.83578Z",
    fill: "#B69084",
    stroke: "#B69084",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8059 11.4701H2.96792C2.78847 11.4701 2.64136 11.3229 2.64136 11.1435C2.64136 10.9641 2.78847 10.8169 2.96792 10.8169H18.8059C18.9853 10.8169 19.1325 10.9641 19.1325 11.1435C19.1325 11.3229 18.9853 11.4701 18.8059 11.4701Z",
    fill: "#B69084",
    stroke: "#B69084",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8059 14.1044H2.96792C2.78847 14.1044 2.64136 13.9572 2.64136 13.7778C2.64136 13.5983 2.78847 13.4512 2.96792 13.4512H18.8059C18.9853 13.4512 19.1325 13.5983 19.1325 13.7778C19.1325 13.9572 18.9853 14.1044 18.8059 14.1044Z",
    fill: "#B69084",
    stroke: "#B69084",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8059 16.7386H8.23652C8.05707 16.7386 7.90991 16.5915 7.90991 16.4121C7.90991 16.2326 8.05707 16.0854 8.23652 16.0854H18.8059C18.9853 16.0854 19.1325 16.2326 19.1325 16.4121C19.1325 16.5915 18.9853 16.7386 18.8059 16.7386Z",
    fill: "#B69084",
    stroke: "#B69084",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_2513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGnb01);
export default __webpack_public_path__ + "static/media/icon-gnb-01.e143c1587c64382df9fed211d3468f89.svg";
export { ForwardRef as ReactComponent };